import React, { Component } from "react";
import { PostData } from "../../api/service";

import {
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  Avatar,
  Button,
  Divider,
} from "@material-ui/core";

import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";

export default class Principal extends Component {
  state = {
    facultyData: [],
    isLoaded: false,
  };

  componentDidMount() {
    let d = {
      dept_code: "OFF",
      type: "PRINCIPAL",
    };

    PostData(`/getemployeebytype`, d).then((resp) => {
      this.setState({
        facultyData: resp,
        isLoaded: true,
      });
    });
  }

  render() {
    return (
      <div>
        <BreadCrumbOwn title="Principal" />

        <Container style={{ marginTop: "40px" }}>
          {this.state.isLoaded &&
            this.state.facultyData.map((el, index) => (
              <Card
                key={index}
                style={{
                  boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                  borderRadius: "10px",
                  padding: "20px",
                }}
              >
                <CardContent>
                  <Grid container spacing={4}>
                    
                    {/* Image */}
                    <Grid item xs={12} md={4} style={{ textAlign: "center" }}>
                      <Avatar
                        src={el.dp?.length > 0 ? el.dp[0] : ""}
                        style={{
                          width: 200,
                          height: 200,
                          margin: "auto",
                          border: "6px solid #f0f0f0",
                        }}
                      />

                      <Typography
                        variant="h6"
                        style={{ marginTop: "15px", fontWeight: 700 }}
                      >
                        {el.name}
                      </Typography>

                      <Typography style={{ color: "#777" }}>
                        {el.designation}
                      </Typography>
                    </Grid>

                    {/* Details */}
                    <Grid item xs={12} md={8}>
                      <Typography
                        variant="h5"
                        style={{ fontWeight: 700, marginBottom: "15px" }}
                      >
                        Principal
                      </Typography>

                      <Divider style={{ marginBottom: "20px" }} />

                      <Typography style={{ marginBottom: "8px" }}>
                        <b>Email:</b>{" "}
                        <a href={`mailto:${el.email}`}>{el.email}</a>
                      </Typography>

                      {el.phone && (
                        <Typography style={{ marginBottom: "8px" }}>
                          <b>Phone:</b>{" "}
                          <a href={`tel:${el.phone}`}>{el.phone}</a>
                        </Typography>
                      )}

                      {el.mobile && (
                        <Typography style={{ marginBottom: "8px" }}>
                          <b>Mobile:</b>{" "}
                          <a href={`tel:${el.mobile}`}>{el.mobile}</a>
                        </Typography>
                      )}

                      {/* {el.date_of_joining && (
                        <Typography style={{ marginBottom: "8px" }}>
                          <b>Date of Joining:</b> {el.date_of_joining}
                        </Typography>
                      )}

                      {el.experience && (
                        <Typography style={{ marginBottom: "8px" }}>
                          <b>Experience:</b> {el.experience}
                        </Typography>
                      )}

                      {el.area_of_research && (
                        <Typography style={{ marginBottom: "8px" }}>
                          <b>Area of Research:</b> {el.area_of_research}
                        </Typography>
                      )} */}

                      {el.cv?.length > 0 && (
                        <Button
                          variant="contained"
                          color="primary"
                          style={{ marginTop: "20px" }}
                          href={el.cv[0]}
                          target="_blank"
                        >
                          View Profile
                        </Button>
                      )}
                    </Grid>
                  </Grid>

                  {/* About Section */}
                  {el.about && (
                    <>
                      <Divider style={{ margin: "30px 0" }} />

                      <Typography
                        variant="h6"
                        style={{ fontWeight: 700, marginBottom: "10px" }}
                      >
                        About the Principal
                      </Typography>

                      <Typography style={{ lineHeight: "1.8" }}>
                        {el.about}
                      </Typography>
                    </>
                  )}
                </CardContent>
              </Card>
            ))}

            <br />
            <br />
        </Container>
      </div>
    );
  }
}